$(document).on('shopify:section:load', function() {
    
    if ($('.freesky-slider').length) {
        $('.freesky-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 4,
                nav: false,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 60,
                        dots: true
                    },
                    768: {
                        items: 2,
                        stagePadding: 30,
                        dots: true
                    },
                    1280: {
                        items: 4,
                        stagePadding: 0,
                        dots: false
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.vertical-images').length) {
        $('.vertical-images .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                smartSpeed: 800,
                margin: 20,
            });
        });
    }

    if ($('.counter').length) {
        $('.counter .count-wrapper h6').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text().match(/\d+/)[0]);
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function formatNumberWithCommas(number) {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumber() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithDigits(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span class="first">${formatNumberWithCommas(random1)}</span>
                    <span class="second">${formatNumberWithCommas(random2)}</span>
                    <span class="third">${formatNumberWithCommas(originalNumber)}</span>
                `);
            }
        
            function animateNumber() {
                setTimeout(() => {
                    $countElement.find('.first').css('top', '-50px');
                    $countElement.find('.second').css('top', '0');
                }, 500);
                setTimeout(() => {
                    $countElement.find('.second').css('top', '-100%');
                    $countElement.find('.third').css('top', '0');
                }, 800);
            }
        
            $this.data('randomNumber', randomNumber);
            $this.data('animateNumber', animateNumber);
        
            randomNumber();
            animateNumber();
        });
    }

    if ($('.counter-v2').length) {
        $('.counter-v2 .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function randomNumberWithZeros(digits) {
                return "0".repeat(digits);
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberV2() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithZeros(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberV2() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 500);
            }
        
            $this.data('randomNumberV2', randomNumberV2);
            $this.data('animateNumberV2', animateNumberV2);
        
            randomNumberV2();
            animateNumberV2();
        });
    }

    circular_animation();
    freesky_slider();
    vertical_slider_two();
    counter();
    counter_v2();

});

$(document).ready(function() {
    
    if ($('.freesky-slider').length) {
        $('.freesky-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 4,
                nav: false,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 0,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 60,
                        dots: true
                    },
                    768: {
                        items: 2,
                        stagePadding: 30,
                        dots: true
                    },
                    1280: {
                        items: 4,
                        stagePadding: 0,
                        dots: false
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.vertical-images').length) {
        $('.vertical-images .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                smartSpeed: 800,
                margin: 20,
            });
        });
    }

    if ($('.counter').length) {
        $('.counter .count-wrapper h6').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text().match(/\d+/)[0]);
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function formatNumberWithCommas(number) {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumber() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithDigits(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span class="first">${formatNumberWithCommas(random1)}</span>
                    <span class="second">${formatNumberWithCommas(random2)}</span>
                    <span class="third">${formatNumberWithCommas(originalNumber)}</span>
                `);
            }
        
            function animateNumber() {
                setTimeout(() => {
                    $countElement.find('.first').css('top', '-50px');
                    $countElement.find('.second').css('top', '0');
                }, 500);
                setTimeout(() => {
                    $countElement.find('.second').css('top', '-100%');
                    $countElement.find('.third').css('top', '0');
                }, 800);
            }
        
            $this.data('randomNumber', randomNumber);
            $this.data('animateNumber', animateNumber);
        
            randomNumber();
            animateNumber();
        });
    }

    if ($('.counter-v2').length) {
        $('.counter-v2 .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function randomNumberWithZeros(digits) {
                return "0".repeat(digits);
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberV2() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithZeros(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberV2() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 500);
            }
        
            $this.data('randomNumberV2', randomNumberV2);
            $this.data('animateNumberV2', animateNumberV2);
        
            randomNumberV2();
            animateNumberV2();
        });
    }

    circular_animation();
    freesky_slider();
    vertical_slider_two();
    counter();
    counter_v2();

});

$(window).on('resize', function() {
    circular_animation();
});

$(window).on('scroll', function() {
    circular_animation();
    freesky_slider();
    vertical_slider_two();
    counter();
    counter_v2();
});

function circular_animation() {
    if ($('.circular-animation').length) {
        $('.circular-animation').each(function() {
            let el = $(this);

            if (el.is($('body section:first'))) {
                el.find('.sticky').css({
                    'height': `${hSize - $('.header').height()}px`,
                    'top': `${$('.header').height()}px`
                });
                el.find('.data-container').css('height', `${hSize - $('.header').height()}px`);
            }
            else {
                el.find('.sticky').css({
                    'height': '100vh',
                    'top': '0'
                });
                el.find('.data-container').css('height', '100vh');
            }

            let scrolled = visiblePercent(el) - 20;

            let scroll_1 = Math.min(Math.max(scrolled, 0), 10);
            let scroll_2 = Math.min(Math.max(scrolled, 15), 25) - 15;
            let scroll_3 = Math.min(Math.max(scrolled, 30), 40) - 30;

            if (scrolled <= 10) {
                el.find('.data-container:nth-child(1)').css('opacity', '1');
                el.find('.data-container:nth-child(2)').css('opacity', '0');
                el.find('.data-container:nth-child(3)').css('opacity', '0');
                el.find('.data-container:nth-child(4)').css('opacity', '0');

                el.find('.data-container:nth-child(1) .blur span').css({
                    'filter': `blur(${10-scroll_1}px)`,
                    'top': `${20-(scroll_1*2)}px`
                });
            }

            if (scrolled >= 15 && scrolled <= 25) {
                el.find('.data-container:nth-child(1)').css('opacity', '0');
                el.find('.data-container:nth-child(2)').css('opacity', '1');
                el.find('.data-container:nth-child(3)').css('opacity', '0');
                el.find('.data-container:nth-child(4)').css('opacity', '0');
                
                el.find('.data-container:nth-child(2) .blur span').css({
                    'filter': `blur(${10-scroll_2}px)`,
                    'top': `${20-(scroll_2*2)}px`
                });
            }

            if (scrolled >= 30 && scrolled <= 40) {
                el.find('.data-container:nth-child(1)').css('opacity', '0');
                el.find('.data-container:nth-child(2)').css('opacity', '0');
                el.find('.data-container:nth-child(3)').css('opacity', '1');
                el.find('.data-container:nth-child(4)').css('opacity', '0');
                
                el.find('.data-container:nth-child(3) .blur span').css({
                    'filter': `blur(${10-scroll_3}px)`,
                    'top': `${20-(scroll_3*2)}px`
                });
            }

            if (scrolled >= 45) {
                el.find('.data-container:nth-child(1)').css('opacity', '0');
                el.find('.data-container:nth-child(2)').css('opacity', '0');
                el.find('.data-container:nth-child(3)').css('opacity', '0');
                el.find('.data-container:nth-child(4)').css('opacity', '1');
                
                if (scrolled >= 45 && scrolled <= 50) {
                    el.find('.image_1').css('opacity', '1');
                    el.find('.image_2').css('opacity', '0');
                    el.find('.image_3').css('opacity', '0');
                    el.find('.image_4').css('opacity', '0');

                    el.find('.data-container:nth-child(4)').css('clip-path', 'circle(5% at 50% 50%)');

                    el.find('.data-container:nth-child(4) .container').css({
                        'top': '100%',
                        'opacity': '0'
                    });
                }
                if (scrolled >= 51 && scrolled <= 56) {
                    el.find('.image_1').css('opacity', '0');
                    el.find('.image_2').css('opacity', '1');
                    el.find('.image_3').css('opacity', '0');
                    el.find('.image_4').css('opacity', '0');

                    el.find('.data-container:nth-child(4)').css('clip-path', 'circle(15% at 50% 50%)');

                    el.find('.data-container:nth-child(4) .container').css({
                        'top': '100%',
                        'opacity': '0'
                    });
                }
                if (scrolled >= 57 && scrolled <= 62) {
                    el.find('.image_1').css('opacity', '0');
                    el.find('.image_2').css('opacity', '0');
                    el.find('.image_3').css('opacity', '1');
                    el.find('.image_4').css('opacity', '0');

                    el.find('.data-container:nth-child(4)').css('clip-path', 'circle(25% at 50% 50%)');
                    
                    el.find('.data-container:nth-child(4) .container').css({
                        'top': '100%',
                        'opacity': '0'
                    });
                }
                if (scrolled >= 63) {
                    el.find('.image_1').css('opacity', '0');
                    el.find('.image_2').css('opacity', '0');
                    el.find('.image_3').css('opacity', '0');
                    el.find('.image_4').css('opacity', '1');

                    el.find('.data-container:nth-child(4)').css('clip-path', 'circle(100% at 50% 50%)');

                    el.find('.data-container:nth-child(4) .container').css({
                        'top': '0',
                        'opacity': '1'
                    });
                }
            }

            console.log(scrolled);

        });
    }
}

function freesky_slider() {
    if ($('.freesky-slider').length) {
        $('.freesky-slider').each(function() {
            let el = $(this);
            
            if (visiblePercent(el) > 50) {
                el.find('.owl-carousel').css({
                    'right': '0',
                    'opacity': '1'
                });
            }
            else {
                el.find('.owl-carousel').css({
                    'right': '-10%',
                    'opacity': '0'
                });
            }
        });
    }
}

function vertical_slider_two() {
    $('.vertical-slider.two').each(function () {
        let el = $(this);

        let $images = $(this).find('.wrapper .image-container');
        let $data = $(this).find('.wrapper .data-container');

        if ($(this).find('.wrapper').data('size') == 1) {
            $(this).find('.wrapper').css('height', '100vh');
        }
        if ($(this).find('.wrapper').data('size') == 2) {
            $(this).find('.wrapper').css('height', '160vh');

            let scrolled = visiblePercent(el) * 1.6;

            if (scrolled >= 120) {
                $images.find('img:nth-child(1)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });

                $data.find('.data:nth-child(1)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '0',
                    'opacity': '1'
                });
            }
            else {
                $images.find('img:nth-child(1)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '-100%',
                    'right': '0',
                    'opacity': '0'
                });

                $data.find('.data:nth-child(1)').css({
                    'top': '0',
                    'opacity': '1'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '100%',
                    'opacity': '0'
                });
            }
        }
        if ($(this).find('.wrapper').data('size') == 3) {
            $(this).find('.wrapper').css('height', '200vh');

            let scrolled = visiblePercent(el) * 2;

            if (scrolled >= 120 && scrolled < 160) {
                $images.find('img:nth-child(1)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '-100%',
                    'right': '0',
                    'opacity': '0'
                });

                $data.find('.data:nth-child(1)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '0',
                    'opacity': '1'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '100%',
                    'opacity': '0'
                });
            }
            else if (scrolled >= 160) {
                $images.find('img:nth-child(1)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '0',
                    'left': '0',
                    'opacity': '1'
                });
                
                $data.find('.data:nth-child(1)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '-100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '0',
                    'opacity': '1'
                });
            }
            else {
                $images.find('img:nth-child(1)').css({
                    'bottom': '0',
                    'right': '0',
                    'opacity': '1'
                });
                $images.find('img:nth-child(2)').css({
                    'bottom': '-100%',
                    'right': '0',
                    'opacity': '0'
                });
                $images.find('img:nth-child(3)').css({
                    'bottom': '-100%',
                    'right': '0',
                    'opacity': '0'
                });
            
                $data.find('.data:nth-child(1)').css({
                    'top': '0',
                    'opacity': '1'
                });
                $data.find('.data:nth-child(2)').css({
                    'top': '100%',
                    'opacity': '0'
                });
                $data.find('.data:nth-child(3)').css({
                    'top': '100%',
                    'opacity': '0'
                });
            }
        }
    });
}

function counter() {
    if ($('.counter').length) {
        $('.counter').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.count-wrapper h6').each(function () {
                    let $this = $(this);
                    if (!$this.data('hasAnimated') && $this.data('randomNumber') && $this.data('animateNumber')) {
                        $this.data('randomNumber')();
                        $this.data('animateNumber')();
                        $this.data('hasAnimated', true);
                    }
                });
            }
        });    
    }
}

function counter_v2() {
    if ($('.counter-v2').length) {
        $('.counter-v2').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.count span').each(function () {
                    let $this = $(this);
                    if (!$this.data('hasAnimated') && $this.data('randomNumberV2') && $this.data('animateNumberV2')) {
                        $this.data('randomNumberV2')();
                        $this.data('animateNumberV2')();
                        $this.data('hasAnimated', true);
                    }
                });
            }
        });    
    }
}